import { PreInterview, PreInterviewQuery } from '@dreryk/egabinet-pre-interview-frontend-api';

import { useCqrsFind } from '@dreryk/command-query-react-common';
import {
   appendTestableCustomAttribute,
   appendTestableElementAttributes,
   DocIcon,
   Link,
   LinkSize,
   Tooltip,
} from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { visitDetailsTranslationKeys } from '../../../translations';

import { PreInterviewBadge } from './PreInterviewBadge';
import { PreInterviewPreviewContextDialogOpener } from './PreInterviewPreviewContextDialog.opener';

type PreInterviewPreviewLinkProps = { readonly appointmentId: number };

export const PreInterviewPreviewLink = (props: PreInterviewPreviewLinkProps): JSX.Element => {
   const { data: preInterview, loading: preInterviewLoading } = useCqrsFind<PreInterview>(() => {
      const query = new PreInterviewQuery();
      query.appointmentIds = Slot.emptyIfNull([props.appointmentId]);
      return query;
   });

   return (
      <PreInterviewPreviewContextDialogOpener appointmentId={props.appointmentId}>
         {({ setTriggerElement }) => (
            <Tooltip
               content={visitDetailsTranslationKeys.preInterview.tooltip.content}
               testId={'preInterviewTooltip'}
               maxWidth={'290px'}
               disabled={Boolean(preInterview)}
            >
               <div
                  {...appendTestableCustomAttribute('state', preInterviewLoading ? 'pending' : 'idle')}
                  {...appendTestableElementAttributes('preInterviewState')}
               >
                  <Link
                     ref={setTriggerElement}
                     testId={'preInterviewPreview'}
                     label={visitDetailsTranslationKeys.preInterview.actions.preview}
                     size={LinkSize.NORMAL}
                     disabled={!preInterview}
                     icon={
                        <PreInterviewBadge preInterview={preInterview}>
                           <DocIcon />
                        </PreInterviewBadge>
                     }
                  />
               </div>
            </Tooltip>
         )}
      </PreInterviewPreviewContextDialogOpener>
   );
};
